var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CustomTable',{ref:"table",attrs:{"id_table":"liste_courrier_type_tiers","busy":_vm.table_busy,"primaryKey":"model_id","items":_vm.courrier_type},on:{"update:busy":function($event){_vm.table_busy=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }